import { render, staticRenderFns } from "./qyyd.vue?vue&type=template&id=1d48c1bc&scoped=true&"
import script from "./qyyd.vue?vue&type=script&lang=js&"
export * from "./qyyd.vue?vue&type=script&lang=js&"
import style0 from "./qyyd.vue?vue&type=style&index=0&id=1d48c1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48c1bc",
  null
  
)

export default component.exports